import debug from 'bows';
import Filters from './_filters';

const log = debug('excerpts');

class Excerpts extends Filters {
	constructor() {
		super();

		this.pagination = document.querySelector('.excerpts__pagination');
		this.items = document.querySelector('.excerpts__items');

		log(this);
	}
}

export default Excerpts;
